<template>
  <div class="wms-field-defination">
    <b-container fluid class="headLine" id="common-mapping-head">
      <div class="container-fluid">
        <h6 class="title">{{ setting.wmsName }} の定義</h6>
        <!-- Start header mapping WMS -->
        <span class="sub-title">
          アップロードしようとしているファイルの左列から順に全ての項目を登録してください。
        </span>
        <!-- End header mapping WMS -->
      </div>

      <div class="container-right">
        <!-- Start button add mapping WMS -->
        <a class="add-single" @click="addWmsItem">
          <span class="material-icons"> add </span>
          追加
        </a>
        <a class="add-all" @click="triggerAddAll" v-if="!isAddAll">
          <span class="material-icons"> add </span>
          一括追加
        </a>
        <!-- 一括追加フィールド -->
        <b-input-group
          class="d-flex px-0 w-auto"
          v-if="isAddAll"
          v-click-outside="handleCloseCollectAdd"
        >
          <b-form-input
            size="xs"
            type="search"
            placeholder="カンマ[,]区切りで入力"
            class="custom_form"
            v-model="collect"
            @keyup.enter="onCollectAdded"
            autofocus
          ></b-form-input>
          <b-input-group-append>
            <b-button
              size="xs"
              variant="info"
              class="pb-0 pt-0"
              @click="onCollectAdded"
              >追加</b-button
            >
          </b-input-group-append>
        </b-input-group>
        <!-- End button add mapping WMS -->
      </div>
    </b-container>
    <hr class="m-0" />
    <div id="scrollspy-mapping">
      <div class="no-data" v-if="isEmptyData">
        <span>項目を追加してください。</span>
      </div>
      <b-container fluid class="wms-item-mapping-list">
        <!-- Start table mapping WMS -->
        <draggable
          v-model="wmsItemList"
          filter=".noAcceptDrag"
          :preventOnFilter="false"
        >
          <div v-for="(wmsItem, index) in wmsItemList" :key="index">
            <div class="item-mapping" :id="`${mappingNo}-${index}`">
              <span class="ordinalNumber">{{ index + 1 }}列</span>
              <b-list-group-item
                :class="[
                  chooseIndex === index && !editLabelList[index]
                    ? 'hovering'
                    : ''
                ]"
                @mousedown="handleShowIconDragById(index)"
                @mouseover="handleShowIconDragById(index)"
                @mouseout="chooseIndex = null"
              >
                <b-container fluid class="item-column">
                  <div class="custom-draggable">
                    <div class="left-column">
                      <span
                        :class="[
                          'icon_drag drag_indicator material-icons material-icons-outlined',
                          chooseIndex === index || editLabelList[index]
                            ? 'd-flex'
                            : 'd-none'
                        ]"
                      >
                        drag_indicator
                      </span>
                      <div :class="['d-flex', editLabelList[index] ? 'w-100' : 'hovering-bg-color']">
                        <editable-label
                          :class="[
                            'wms_input textarea pl-0',
                            editLabelList[index] ? 'w-100' : ''
                          ]"
                          :ref="'externalEditableLabel' + index"
                          :text="wmsItem.wmsItemName"
                          :maxlength="64"
                          v-on:blur="focusOut"
                          v-on:text-updated="onWmsEditEnd(...arguments, index)"
                          v-on:edit-mode="onEditMode(...arguments, index)"
                        />
                        <!-- Edit icon -->
                        <a
                          class="d-flex align-items-center"
                          @click="onEdit(index, wmsItem)"
                        >
                          <span
                            class="material-icons edit_icon"
                            v-show="
                              chooseIndex === index && !editLabelList[index]
                            "
                          >
                            edit
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="right-column">
                    <!-- Delete icon -->
                    <a
                      @click="onItemDelete(index)"
                      class="d-flex align-items-center text-decoration-none"
                    >
                      <span class="material-icons delete_icon"> close </span>
                    </a>
                  </div>
                </b-container>
              </b-list-group-item>
            </div>
          </div>
        </draggable>
        <!-- End table mapping WMS -->
      </b-container>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
// import mixinAutoResize from '../../mixins/autoResize.js'
import FlashMessage from '../../common/flash-message.component'
import EditableLabel from '../custom-components/EditableLabel'
import Vue from 'vue'
import AppConstants from '../../constants/app.constants'
import ErrorCdMsgConstants from '../../constants/error-cd-msg.constants'

const WMS_VALUE = 'WMS項目'
export default {
  // mixins: [mixinAutoResize],
  props: {
    mappingNo: String,
    setting: Object
  },
  components: {
    draggable,
    EditableLabel
  },
  data() {
    return {
      wmsItemList: [],
      mstItemList: [],
      chooseIndex: null,
      isLoading: false,
      editLabelList: [],
      isAddAll: false,
      isAdd: false,
      collect: '',
      isEmptyData: false,
      errCdList: ['API_WMS_FIELD_DEFINITION_ERR_001', 'API_WMS_FIELD_DEFINITION_ERR_002'],
      deletedWmsNo: []
    }
  },
  created() {
    this.featchDataWmsItem()
  },
  watch: {
    isLoading() {
      this.$emit('isLoading', this.isLoading)
    },
    wmsItemList(newValue) {
      this.isEmptyData = !newValue.length
    }
  },
  computed: {},
  methods: {
    /** トリガー すべて追加 */
    triggerAddAll() {
      if (this.isAddAll === true) {
        this.isAddAll = false
      } else this.isAddAll = true
    },
    /**
     * 編集アイコンを表示
     * @param {number} index リスト データのインデックス
     */
    handleShowIconDragById(index) {
      this.chooseIndex = index
    },
    /** まとめて追加処理 */
    onCollectAdded() {
      // 一括追加ボタンをクリックした後、保存ボタンにフォーカスする
      // 次のエンターにsaveMappingメソッドを呼び出します
      document.getElementById('save_and_next').focus()
      // Avoid space and close input
      if (this.collect.trim().length === 0) {
        this.isAddAll = !this.isAddAll
        return
      }
      const splitList = this.collect.trim().split(',')
      // Check the items contain over 64 chars
      if (splitList.filter(element => element.length > 64).length > 0) {
        FlashMessage.getInstance().showErrorMessage(
          '追加できませんでした。文字数制限を超えている項目があります。各項目名は64文字以下にしてください。'
        )
        return
      }
      splitList.forEach((solitItemName, index) => {
        const addItem = this.$_createWmsItem(solitItemName || WMS_VALUE)
        this.$_addedWmsItem(addItem)
      })
      let index = this.wmsItemList.length - 1
      Vue.nextTick(() => this.scrollToEnd(index))
      if (this.isAddAll) {
        this.isAddAll = !this.isAddAll
        this.collect = ''
      }
    },
    /** クローズは WMS を追加します */
    handleCloseCollectAdd() {
      this.isAddAll = !this.isAddAll
      this.collect = ''
    },
    // WMS追加アイテムの作成
    $_createWmsItem(itemName) {
      return {
        wmsItemName: itemName,
        editable: false
      }
    },
    /** WMS を追加 */
    $_addedWmsItem(addItem = { isItemName: WMS_VALUE }) {
      this.wmsItemList.push(addItem)
    },
    /**
     * WMSアイテムの削除
     */
    onItemDelete(removeIndex) {
      if (this.wmsItemList[removeIndex].wmsNo) {
        this.deletedWmsNo.push(this.wmsItemList[removeIndex].wmsNo)
      }
      this.wmsItemList.splice(removeIndex, 1)
    },

    /** WMSのフォームのフォーカスイベント */
    focusIn() {
      console.log('フォーカスいん')
    },
    /** WMS フォーム ブラー イベント */
    focusOut() {
      this.wmsItemList.forEach((wmsItem, index) => {
        if (wmsItem.wmsItemName) {
          wmsItem.editable = false
        }
      })
    },
    /**
     * WMSのフォーム編集ボタン
     * @param {number} index アイテムのインデックス ラベルを編集する必要があります
     * @param {object} wms 編集が必要な項目の値
     */
    onEdit(index, wms) {
      this.chooseIndex = null
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs['externalEditableLabel' + index][0].switchToEditMode()
        }, 1)
        wms.editable = !wms.editable
      })
      this.editLabelList[index] = true
    },
    /**
     * WMS が更新されました
     * @param {string} newValue 編集が必要なアイテムの新しい値
     * @param {number} index 編集が必要なアイテムのインデックス
     */
    onWmsEditEnd(newValue, index) {
      this.$set(this.wmsItemList[index], 'wmsItemName', newValue)
      this.focusOut()
    },
    /**
     * イベント編集モードの扱い、
     * 編集アイコンを非表示にし、ラベルモードを編集モードに変更
     * @param {boolean} editMode レコード編集モード
     * @param {number} index レコード インデックス
     */
    onEditMode(editMode, index) {
      this.chooseIndex = null
      this.$set(this.editLabelList, index, editMode)
    },
    /** WMSを1つ追加 */
    addWmsItem() {
      const addItem = this.$_createWmsItem(WMS_VALUE)
      this.wmsItemList.push(addItem)
      let index = this.wmsItemList.length - 1
      this.onEdit(index, addItem)
      Vue.nextTick(() => this.scrollToEnd(index))
    },
    /**
     * 最後までスクロール
     * @param {number} lastIndex スクロールする必要があるインデックス
     */
    scrollToEnd(lastIndex) {
      const lastElm = document.getElementById(
        `${this.mappingNo}-` + lastIndex
      )
      const scrollspyElm = document.getElementById('scrollspy-mapping')
      const scrollspyHeight = scrollspyElm.offsetHeight
      if (lastElm.offsetTop > scrollspyHeight) {
        scrollspyElm.scrollTo({
          top: lastElm.offsetTop - scrollspyHeight + lastElm.offsetHeight,
          behavior: 'smooth'
        })
      }
    },
    /** マッピングデータ保存処理 */
    async saveMapping() {
      if (this.wmsItemList.length > AppConstants.MAPPING_WMS_ITEMS_MAX_RECORD) {
        FlashMessage.getInstance().showErrorMsgWithErrorCode(
          ErrorCdMsgConstants.FUNC_MAPPING_WMS_ITEM_EXCEEDS_MAX_RECORDS_ERR_CD,
          ErrorCdMsgConstants.FUNC_MAPPING_WMS_ITEM_EXCEEDS_MAX_RECORDS_ERR_MSG)
        return
      }
      this.isLoading = true
      let request = null
      try {
        let wmsItemData = []
        this.wmsItemList.some((wmsItem, index) => {
          let lineNum = ++index
          // WMSアイテム
          wmsItemData.push({
            mappingNo: this.mappingNo,
            wmsItemName: wmsItem.wmsItemName,
            lineNum: lineNum,
            wmsNo: wmsItem.wmsNo
          })
        })
        request = await this.$axios.post(`/wms-field-definition/${this.mappingNo}`, {
          mstMappingWmsItem: wmsItemData, deletedWmsNo: this.deletedWmsNo
        })
        this.featchDataWmsItem()
        FlashMessage.getInstance().showSuccessMessage('保存完了。')
        this.isLoading = false
      } catch (err) {
        this.isLoading = false
        FlashMessage.getInstance().parseAndShowErrorMessage(err)
        if (!err || !err.response || !err.response.data) {
          return
        }
        let errObj = err.response.data
        let errCd = errObj.errCd
        this.errCdList.forEach(errCode => {
          if (errCode === errCd) {
            this.featchDataWmsItem()
          }
        })
      }
      return request
    },
    /** WMS データを取得する */
    async featchDataWmsItem() {
      let checkWmsListItems
      this.deletedWmsNo = []
      const respon = await this.$axios.get(
        `wms-field-definition/${this.mappingNo}`
      )
      const wmsItemList = respon.data.mstMappingWmsItem
      const mstItemList = respon.data.mstMappingIsItem
      if (wmsItemList.length) {
        this.wmsItemList = [...JSON.parse(JSON.stringify(wmsItemList))]
        this.isEmptyData = false
      } else {
        this.isEmptyData = true
      }
      checkWmsListItems = Boolean(wmsItemList.length)
      if (mstItemList.length) {
        this.mstItemList = [...JSON.parse(JSON.stringify(mstItemList))]
      }
      // Emit event after save wms success
      this.$emit('check-wms-item-mapped', {
        checkWmsListItems
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wms-field-defination {
  // 80px (Area tab and action button mapping)
  height: calc(100% - 80px);
  padding-left: 15px;
  .wms-item-mapping-list {
    padding-left: 15px;
    padding-right: 0px;
  }
  .item-mapping {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100% !important;
    .hovering {
      background: $text_hover_bg_color;
    }
    .ordinalNumber {
      @include responsive-fs(16);
      white-space: nowrap;
      min-width: 50px;
      width: 5%;
      max-width: 120px;
    }
    .list-group-item {
      background: #ffffff;
      border: 1px solid #d6d6d6;
      border-radius: 4px;
      padding: 2px 0px;
      margin: 2px 0 1px 0;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      width: 100%;
      height: 48px;
      &.hovering {
        cursor: pointer;
        background: $text_hover_bg_color;
      }
      .item-column {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .custom-draggable {
          display: flex;
          align-content: center;
          justify-items: center;
          width: 100%;
          .icon_drag {
            cursor: pointer;
            color: #afafae;
            margin-right: 7px;
            &:hover {
              background: $text_hover_bg_color;
            }
          }
          .left-column {
            display: flex;
            align-items: center;
            height: 26px;
            width: 100%;
            .input-label {
              width: 100%;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
            a {
              text-decoration: none;
            }
            /deep/ .editableLabel-input {
              width: 100% !important;
              padding: 7px 0 7px 16px;
              background: $text_hover_bg_color;
              border: 1px solid #4e66a6;
              border-radius: 4px;
            }
            /deep/ .editableLabel-label {
              word-break: break-all;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
            .hovering-bg-color {
              padding: 8px;
              &:hover {
                background: $text_hover_bg_color;
              }
            }
          }
        }
      }
    }
  }
  .headLine {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0px 0px 10px 0px;
    padding-right: 0px !important;
    padding-left: 0px !important;
    max-height: 100px;
    height: 55px;
    .sub-title {
      font-weight: 400;
      @include responsive-fs(12);
      color: #666563;
      @include textOverflowEllipsis(true);
    }
    .container-fluid {
      padding-right: 50px;
      .title {
        font-weight: 900;
        margin-right: 2px;
        @include textOverflowEllipsis(true);
      }
    }
    .container-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: nowrap;
      width: auto;
      padding-right: 0px;
      .add-single,
      .add-all {
        display: flex;
        align-items: center;
        text-decoration: none;
        font-weight: 400;
        @include responsive-fs(18);
        line-height: 160%;
        user-select: none;
        &:hover {
          cursor: pointer;
        }
      }
      .add-single {
        margin-right: 24px;
        min-width: fit-content;
      }
      .add-all {
        min-width: fit-content;
      }
      .input-group {
        text-indent: 0px !important;
        min-width: 311px;
        @include media-breakpoint-default() {
          min-width: 258px;
        }
        .custom_form {
          border-right: none;
          border-right: none;
          position: relative;
        }
      }
    }
  }

  // MATERIAL ICONS CUSTOM
  .material-icons {
    &.edit_icon {
      color: $sucess;
      cursor: pointer;
      @include responsive-fs(18);
    }
    &.delete_icon {
      color: #afafae;
      &:hover {
        background: $text_hover_bg_color;
      }
    }
    &.delete_icon:hover {
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/CommonWmsFieldDefinition.vue